import type { IToggleBranchUserDataUpdateParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const toggleBranchUserDataUpdate = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/toggleBranchUserDataUpdate`,
  async (params: IToggleBranchUserDataUpdateParams, { rejectWithValue }) => {
    const { branch } = params;

    const { userDataUpdate } = branch;

    try {
      await apiService.branches.toggleBranchUserDataUpdate({
        ...params,
        userDataUpdate: {
          enabled: !userDataUpdate.enabled,
        },
      });

      const message = `Los datos obligatorios fueron ${
        userDataUpdate.enabled ? 'desactivados' : 'habilitados'
      } correctamente para esta sucursal.`;

      notificationService.global.success(message);
    } catch (error) {
      notificationService.global.error(
        `Error al ${userDataUpdate.enabled ? 'desactivar' : 'habilitar'} los datos obligatorios.`,
      );

      return rejectWithValue(error);
    }
  },
);

export const toggleBranchUserDataUpdateReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(toggleBranchUserDataUpdate.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(toggleBranchUserDataUpdate.rejected, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;
    })
    .addCase(toggleBranchUserDataUpdate.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
